export const zodiacSigns = [
  {
    id: 1,
    name: "Aries",
    tamilName: "மேஷம்",
    tamilNameEn: "Mesham",
    tamilSlug: "mesham",
    symbol: "♈",
    dates: "Mar 21 - Apr 19",
    element: "Fire",
    ruling_planet: "Mars",
    quality: "Cardinal",
    color: "#ef4444",
    traits: ["Courageous", "Determined", "Confident", "Enthusiastic", "Optimistic"],
    compatibility: ["Leo", "Sagittarius", "Gemini", "Aquarius"],
    lucky_numbers: [1, 8, 17],
    lucky_day: "Tuesday",
    description: "Aries is the first sign of the zodiac, and that's pretty much how those born under this sign see themselves: first. Aries are the leaders of the pack, first in line to get things going.",
    image: "/images/zodiac/aries.png"
  },
  {
    id: 2,
    name: "Taurus",
    tamilName: "ரிஷபம்",
    tamilNameEn: "Rishabam",
    tamilSlug: "rishabam",
    symbol: "♉",
    dates: "Apr 20 - May 20",
    element: "Earth",
    ruling_planet: "Venus",
    quality: "Fixed",
    color: "#22c55e",
    traits: ["Reliable", "Patient", "Practical", "Devoted", "Responsible"],
    compatibility: ["Virgo", "Capricorn", "Cancer", "Pisces"],
    lucky_numbers: [2, 6, 9, 12],
    lucky_day: "Friday",
    description: "Taurus is an earth sign represented by the bull. Like their celestial spirit animal, Taureans enjoy relaxing in serene environments surrounded by soft sounds, soothing aromas, and succulent flavors.",
    image: "/images/zodiac/taurus.png"
  },
  {
    id: 3,
    name: "Gemini",
    tamilName: "மிதுனம்",
    tamilNameEn: "Mithunam",
    tamilSlug: "mithunam",
    symbol: "♊",
    dates: "May 21 - Jun 20",
    element: "Air",
    ruling_planet: "Mercury",
    quality: "Mutable",
    color: "#eab308",
    traits: ["Gentle", "Affectionate", "Curious", "Adaptable", "Quick learner"],
    compatibility: ["Libra", "Aquarius", "Aries", "Leo"],
    lucky_numbers: [5, 7, 14, 23],
    lucky_day: "Wednesday",
    description: "Gemini is represented by the twins, and this air sign was interested in so many pursuits that it had to double itself. Spontaneous, playful, and adorably erratic, Gemini is driven by curiosity.",
    image: "/images/zodiac/gemini.png"
  },
  {
    id: 4,
    name: "Cancer",
    tamilName: "கடகம்",
    tamilNameEn: "Kadagam",
    tamilSlug: "kadagam",
    symbol: "♋",
    dates: "Jun 21 - Jul 22",
    element: "Water",
    ruling_planet: "Moon",
    quality: "Cardinal",
    color: "#a1a1aa",
    traits: ["Tenacious", "Highly imaginative", "Loyal", "Emotional", "Sympathetic"],
    compatibility: ["Scorpio", "Pisces", "Taurus", "Virgo"],
    lucky_numbers: [2, 3, 15, 20],
    lucky_day: "Monday",
    description: "Cancer is a cardinal water sign. Represented by the crab, this oceanic crustacean seamlessly weaves between the sea and shore, representing Cancer's ability to exist in both emotional and material realms.",
    image: "/images/zodiac/cancer.png"
  },
  {
    id: 5,
    name: "Leo",
    tamilName: "சிம்மம்",
    tamilNameEn: "Simham",
    tamilSlug: "simham",
    symbol: "♌",
    dates: "Jul 23 - Aug 22",
    element: "Fire",
    ruling_planet: "Sun",
    quality: "Fixed",
    color: "#f97316",
    traits: ["Creative", "Passionate", "Generous", "Warm-hearted", "Cheerful"],
    compatibility: ["Aries", "Sagittarius", "Gemini", "Libra"],
    lucky_numbers: [1, 3, 10, 19],
    lucky_day: "Sunday",
    description: "Leo is represented by the lion, and these spirited fire signs are the kings and queens of the celestial jungle. They're delighted to embrace their royal status: Vivacious, theatrical, and passionate.",
    image: "/images/zodiac/leo.png"
  },
  {
    id: 6,
    name: "Virgo",
    tamilName: "கன்னி",
    tamilNameEn: "Kanni",
    tamilSlug: "kanni",
    symbol: "♍",
    dates: "Aug 23 - Sep 22",
    element: "Earth",
    ruling_planet: "Mercury",
    quality: "Mutable",
    color: "#84cc16",
    traits: ["Loyal", "Analytical", "Kind", "Hardworking", "Practical"],
    compatibility: ["Taurus", "Capricorn", "Cancer", "Scorpio"],
    lucky_numbers: [5, 14, 15, 23],
    lucky_day: "Wednesday",
    description: "Virgo is an earth sign historically represented by the goddess of wheat and agriculture. Virgos are logical, practical, and systematic in their approach to life.",
    image: "/images/zodiac/virgo.png"
  },
  {
    id: 7,
    name: "Libra",
    tamilName: "துலாம்",
    tamilNameEn: "Thulam",
    tamilSlug: "thulam",
    symbol: "♎",
    dates: "Sep 23 - Oct 22",
    element: "Air",
    ruling_planet: "Venus",
    quality: "Cardinal",
    color: "#ec4899",
    traits: ["Cooperative", "Diplomatic", "Gracious", "Fair-minded", "Social"],
    compatibility: ["Gemini", "Aquarius", "Leo", "Sagittarius"],
    lucky_numbers: [4, 6, 13, 15],
    lucky_day: "Friday",
    description: "Libra is an air sign represented by the scales, an association that reflects Libra's fixation on balance and harmony. Libra is obsessed with symmetry and strives to create equilibrium in all areas of life.",
    image: "/images/zodiac/libra.png"
  },
  {
    id: 8,
    name: "Scorpio",
    tamilName: "விருச்சிகம்",
    tamilNameEn: "Viruchigam",
    tamilSlug: "viruchigam",
    symbol: "♏",
    dates: "Oct 23 - Nov 21",
    element: "Water",
    ruling_planet: "Pluto",
    quality: "Fixed",
    color: "#991b1b",
    traits: ["Resourceful", "Brave", "Passionate", "Stubborn", "True friend"],
    compatibility: ["Cancer", "Pisces", "Virgo", "Capricorn"],
    lucky_numbers: [8, 11, 18, 22],
    lucky_day: "Tuesday",
    description: "Scorpio is one of the most misunderstood signs of the zodiac. Scorpio is a water sign that uses emotional energy as fuel, cultivating powerful wisdom through both the physical and unseen realms.",
    image: "/images/zodiac/scorpio.png"
  },
  {
    id: 9,
    name: "Sagittarius",
    tamilName: "தனுசு",
    tamilNameEn: "Dhanusu",
    tamilSlug: "dhanusu",
    symbol: "♐",
    dates: "Nov 22 - Dec 21",
    element: "Fire",
    ruling_planet: "Jupiter",
    quality: "Mutable",
    color: "#7c3aed",
    traits: ["Generous", "Idealistic", "Great sense of humor", "Adventurous", "Optimistic"],
    compatibility: ["Aries", "Leo", "Libra", "Aquarius"],
    lucky_numbers: [3, 7, 9, 12],
    lucky_day: "Thursday",
    description: "Sagittarius is the last fire sign of the zodiac. Represented by the archer, Sagittarians are always on a quest for knowledge. They launch their many pursuits like blazing arrows, chasing after adventures.",
    image: "/images/zodiac/sagittarius.png"
  },
  {
    id: 10,
    name: "Capricorn",
    tamilName: "மகரம்",
    tamilNameEn: "Magaram",
    tamilSlug: "magaram",
    symbol: "♑",
    dates: "Dec 22 - Jan 19",
    element: "Earth",
    ruling_planet: "Saturn",
    quality: "Cardinal",
    color: "#78716c",
    traits: ["Responsible", "Disciplined", "Self-control", "Good managers", "Ambitious"],
    compatibility: ["Taurus", "Virgo", "Scorpio", "Pisces"],
    lucky_numbers: [4, 8, 13, 22],
    lucky_day: "Saturday",
    description: "Capricorn is the last earth sign and is represented by the sea goat, a mythological creature with the body of a goat and tail of a fish. Capricorns are skilled at navigating both the material and emotional realms.",
    image: "/images/zodiac/capricorn.png"
  },
  {
    id: 11,
    name: "Aquarius",
    tamilName: "கும்பம்",
    tamilNameEn: "Kumbham",
    tamilSlug: "kumbham",
    symbol: "♒",
    dates: "Jan 20 - Feb 18",
    element: "Air",
    ruling_planet: "Uranus",
    quality: "Fixed",
    color: "#0ea5e9",
    traits: ["Progressive", "Original", "Independent", "Humanitarian", "Visionary"],
    compatibility: ["Gemini", "Libra", "Aries", "Sagittarius"],
    lucky_numbers: [4, 7, 11, 22],
    lucky_day: "Saturday",
    description: "Aquarius is the last air sign of the zodiac and is represented by the water bearer. Aquarius is the most humanitarian astrological sign, dedicated to making the world a better place.",
    image: "/images/zodiac/aquarius.png"
  },
  {
    id: 12,
    name: "Pisces",
    tamilName: "மீனம்",
    tamilNameEn: "Meenam",
    tamilSlug: "meenam",
    symbol: "♓",
    dates: "Feb 19 - Mar 20",
    element: "Water",
    ruling_planet: "Neptune",
    quality: "Mutable",
    color: "#06b6d4",
    traits: ["Compassionate", "Artistic", "Intuitive", "Gentle", "Wise"],
    compatibility: ["Cancer", "Scorpio", "Taurus", "Capricorn"],
    lucky_numbers: [3, 9, 12, 15],
    lucky_day: "Thursday",
    description: "Pisces is the last sign of the zodiac and is represented by two fish swimming in opposite directions. This represents the constant division of Pisces's attention between fantasy and reality.",
    image: "/images/zodiac/pisces.png"
  }
];

export const planets = [
  { name: "Sun", symbol: "☉", significance: "Soul, Ego, Self-expression" },
  { name: "Moon", symbol: "☽", significance: "Emotions, Intuition, Mother" },
  { name: "Mars", symbol: "♂", significance: "Energy, Action, Desire" },
  { name: "Mercury", symbol: "☿", significance: "Communication, Intellect" },
  { name: "Jupiter", symbol: "♃", significance: "Luck, Expansion, Wisdom" },
  { name: "Venus", symbol: "♀", significance: "Love, Beauty, Harmony" },
  { name: "Saturn", symbol: "♄", significance: "Discipline, Karma, Lessons" },
  { name: "Rahu", symbol: "☊", significance: "Desires, Obsession, Growth" },
  { name: "Ketu", symbol: "☋", significance: "Spirituality, Liberation" }
];

export const houses = [
  { number: 1, name: "Ascendant/Lagna", significance: "Self, Personality, Physical Body" },
  { number: 2, name: "Dhana Bhava", significance: "Wealth, Family, Speech" },
  { number: 3, name: "Sahaj Bhava", significance: "Siblings, Courage, Communication" },
  { number: 4, name: "Sukha Bhava", significance: "Home, Mother, Happiness" },
  { number: 5, name: "Putra Bhava", significance: "Children, Creativity, Romance" },
  { number: 6, name: "Ari Bhava", significance: "Health, Enemies, Service" },
  { number: 7, name: "Yuvati Bhava", significance: "Marriage, Partnership, Business" },
  { number: 8, name: "Randhra Bhava", significance: "Longevity, Transformation, Occult" },
  { number: 9, name: "Dharma Bhava", significance: "Luck, Religion, Father" },
  { number: 10, name: "Karma Bhava", significance: "Career, Status, Authority" },
  { number: 11, name: "Labha Bhava", significance: "Gains, Income, Friends" },
  { number: 12, name: "Vyaya Bhava", significance: "Losses, Spirituality, Foreign" }
];

export const getZodiacByName = (name) => {
  const lower = name.toLowerCase();
  return zodiacSigns.find(sign => sign.name.toLowerCase() === lower) ||
    zodiacSigns.find(sign => lower.startsWith(sign.name.toLowerCase()));
};

export const getZodiacById = (id) => {
  return zodiacSigns.find(sign => sign.id === id);
};

export const getElementsByType = (element) => {
  return zodiacSigns.filter(sign => sign.element === element);
};
